import { FC, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { UserHomeBaseForm } from "Bands/components";
import { editUserHomeBase, userHomeBaseSelectorCreator } from "Bands/state";
import { IUserHomeBase, USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { Train } from "shared/assets/icons";

const { userHomeBase: baseCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const EditUserHomeBaseModal: FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const baseIdSelector = useMemo(() => userHomeBaseSelectorCreator(id), [id]);
  const base = useSelector(baseIdSelector);

  const buttons: IFormButtons = {
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IUserHomeBase) => {
    dispatch(editUserHomeBase({ id, data }));
  };

  return (
    <UserEntityModal
      defaultValues={base}
      title={baseCopy.edit.title}
      icon={Train}
      action={USER_ACTIONS.editUserHomeBase}
      buttons={buttons}
      successMessage={baseCopy.messages.edited}
      Component={UserHomeBaseForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
    />
  );
};
